export default __webpack_public_path__ + "static/media/marvel.1868199e.jpg";